import {map} from 'lodash';
import {
    ComposedChart, Area, XAxis, Tooltip, CartesianGrid, Line, ResponsiveContainer,
    LineProps, AreaProps, XAxisProps, CartesianGridProps, Margin, YAxis, YAxisProps, TooltipProps,
} from 'recharts';

type Props = {
    data: any[];
    minWidth?: number;
    xAxis?: XAxisProps;
    yAxis?: YAxisProps;
    margin?: Partial<Margin>;
    grid?: CartesianGridProps;
    lines?: LineProps[];
    areas?: AreaProps[];
    tooltip?: TooltipProps;
};

export const Chart: React.FC<Props> = ({data, tooltip, xAxis, yAxis, lines, areas, grid, margin, minWidth = 250}: Props) => (
    <ResponsiveContainer minWidth={minWidth}>
        <ComposedChart
            data={data}
            margin={margin}
        >
            {tooltip && <Tooltip {...tooltip} />}
            {xAxis && <XAxis {...xAxis} />}
            {yAxis && <YAxis {...yAxis} />}
            {grid && <CartesianGrid {...grid} />}
            {map(lines, (line, i) => <Line key={`line-${i}`} {...line} />)}
            {map(areas, (area, i) => <Area key={`area-${i}`} {...area} />)}
        </ComposedChart>
    </ResponsiveContainer>
);